import { OptionType } from "components/select-form-field/select-form-field.component";

export const enum TagTypes {
  PATIENT = "Patient",
  PATIENT_PRODUCT = "PatientProduct",
  INVENTORY_PRODUCT = "InventoryProduct",
  APPOINTMENT = "Appointment",
  SALE = "Sale",
  FAX = "Fax",
  CHART_NOTE = "ChartNote",
  TASK = "Task"
}

export const TagTypeOptions: OptionType[] = [
  { value: "Patient", label: "Patient" },
  { value: "PatientProduct", label: "Patient Devices" },
  { value: "InventoryProduct", label: "Clinic Stock" },
  { value: "Appointment", label: "Appointment" },
  { value: "Sale", label: "Sale" },
  { value: "Fax", label: "Fax" },
  { value: "ChartNote", label: "Chart Note" },
  { value: "Task", label: "Task" }
];

export const AUTOCOMPLETE_PAGE_SIZE = 100;
